import React, { useEffect, useState } from 'react';
import { Breadcrumb, Modal, Button } from 'antd';
import { Link } from 'react-router-dom';
import { Api_VariavelGlobal } from '../global';
import './StoreHoursManager.css';

const daysMap = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'];

export default function StoreHoursManager() {
  const [hours, setHours] = useState([]);
  const [loading, setLoading] = useState(false);

  const [dayOfWeek, setDayOfWeek] = useState(1);
  const [openTime, setOpenTime] = useState('08:00');
  const [closeTime, setCloseTime] = useState('18:00');

  const [selectedHourId, setSelectedHourId] = useState(null);
  const [breakStart, setBreakStart] = useState('12:00');
  const [breakEnd, setBreakEnd] = useState('13:00');
  const [isModalVisible, setIsModalVisible] = useState(false);

  useEffect(() => {
    fetchHours();
  }, []);

  const fetchHours = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${Api_VariavelGlobal}/api/storehours`);
      if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
      const data = await res.json();
      setHours(data);
    } catch (err) {
      alert('Erro ao carregar horários: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  const addHour = async () => {
    try {
      const res = await fetch(`${Api_VariavelGlobal}/api/storehours`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          day_of_week: dayOfWeek,
          open_time: openTime + ':00',
          close_time: closeTime + ':00',
        }),
      });
      if (!res.ok) throw new Error('Erro ao adicionar horário');
      await fetchHours();
    } catch (err) {
      alert(err.message);
    }
  };

  const addBreak = async () => {
    if (!selectedHourId) {
      alert('Selecione um horário para adicionar intervalo');
      return;
    }
    try {
      const res = await fetch(`${Api_VariavelGlobal}/api/storehours/${selectedHourId}/breaks`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          break_start: breakStart + ':00',
          break_end: breakEnd + ':00',
        }),
      });
      if (!res.ok) throw new Error('Erro ao adicionar intervalo');
      await fetchHours();
    } catch (err) {
      alert(err.message);
    }
  };

  const deleteHour = async (id) => {
    if (!window.confirm('Confirma exclusão deste horário?')) return;
    try {
      const res = await fetch(`${Api_VariavelGlobal}/api/storehours/${id}`, { method: 'DELETE' });
      if (!res.ok) throw new Error('Erro ao excluir horrio');
      await fetchHours();
      if (selectedHourId === id) setSelectedHourId(null);
    } catch (err) {
      alert(err.message);
    }
  };

  const deleteBreak = async (hourId, breakId) => {
    if (!window.confirm('Confirma exclusão deste intervalo?')) return;
    try {
      const res = await fetch(`${Api_VariavelGlobal}/api/storehours/${hourId}/breaks/${breakId}`, { method: 'DELETE' });
      if (!res.ok) throw new Error('Erro ao excluir intervalo');
      await fetchHours();
    } catch (err) {
      alert(err.message);
    }
  };

  return (
    <div className="content-wrapper">
      <h3>Horário de Atendimento</h3>
      <Breadcrumb style={{ marginBottom: 16 }}>
          <Breadcrumb.Item>
            <Link to="/">Início</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Horário de Atendimento</Breadcrumb.Item>
        </Breadcrumb>
    
     {/* Botão para abrir o modal */}
      <Button
        type="primary"
        style={{ marginBottom: 20 }}
        onClick={() => setIsModalVisible(true)}
      >
        Ver Resumo de Horários
      </Button>

      {/* Modal com resumo */}
      <Modal
        title="Resumo de Horários"
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
      >
        {loading ? (
          <p>Carregando...</p>
        ) : (
          <ul className="store-hours-summary">
            {hours.map((h) => (
              <li key={h.id}>
                <strong>{daysMap[h.day_of_week]}</strong>: {h.open_time.slice(0, 5)} às {h.close_time.slice(0, 5)}
                {h.breaks.length > 0 && (
                  <ul>
                    {h.breaks.map((b) => (
                      <li key={b.id}>
                        Intervalo: {b.break_start.slice(0, 5)} às {b.break_end.slice(0, 5)}
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
        )}
      </Modal>
        
      <div className="store-hours-form-container">
  <section className="store-hours-section">
    <h3>Adicionar Novo Horário</h3>
    <label>Dia da Semana:</label>
    <select className="store-hours-input" value={dayOfWeek} onChange={(e) => setDayOfWeek(Number(e.target.value))}>
      {daysMap.map((d, i) => (
        <option key={i} value={i}>{d}</option>
      ))}
    </select>

    <label>Abertura:</label>
    <input type="time" className="store-hours-input" value={openTime} onChange={(e) => setOpenTime(e.target.value)} />

    <label>Fechamento:</label>
    <input type="time" className="store-hours-input" value={closeTime} onChange={(e) => setCloseTime(e.target.value)} />

    <button className="store-hours-button" onClick={addHour}>Adicionar Horário</button>
  </section>

  <section className="store-hours-section">
    <h3>Adicionar Intervalo (Break)</h3>
    <label>Início:</label>
    <input type="time" className="store-hours-input" value={breakStart} onChange={(e) => setBreakStart(e.target.value)} />

    <label>Fim:</label>
    <input type="time" className="store-hours-input" value={breakEnd} onChange={(e) => setBreakEnd(e.target.value)} />

    <button className="store-hours-button" onClick={addBreak}>Adicionar Intervalo</button>
  </section>
</div>
<div className="store-hours-form-container">
      <section className="store-hours-section">
        <h3>Horários Existentes</h3>
        {loading ? (
          <p>Carregando...</p>
        ) : (
          <ul className="store-hours-list">
            {hours.map((h) => (
              <li key={h.id} className="store-hours-item">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <strong>{daysMap[h.day_of_week]} — {h.open_time.slice(0, 5)} às {h.close_time.slice(0, 5)}</strong>
                  <button className="store-hours-delete" onClick={() => deleteHour(h.id)}>Excluir Horrio</button>
                </div>

                <div className="store-hours-breaks">
                  <small>Intervalos:</small>
                  <ul>
                    {h.breaks.length === 0 && <li>Sem intervalos</li>}
                    {h.breaks.map((b) => (
                      <li key={b.id}>
                        {b.break_start.slice(0, 5)} às {b.break_end.slice(0, 5)}
                        <button className="store-hours-delete" onClick={() => deleteBreak(h.id, b.id)}>Excluir</button>
                      </li>
                    ))}
                  </ul>
                </div>

                <label className="store-hours-radio">
                  <input type="radio" name="selectedHour" checked={selectedHourId === h.id} onChange={() => setSelectedHourId(h.id)} />
                  Selecionar para adicionar intervalo
                </label>
              </li>
            ))}
          </ul>
        )}
      </section>
      </div>
    </div>
  );
}
